"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _Visible = _interopRequireDefault(require("@rsuite/icon-font/lib/status/Visible"));

// Generated by script, don't edit it please.
var Visible = (0, _createSvgIcon["default"])({
  as: _Visible["default"],
  ariaLabel: 'visible',
  category: 'status',
  displayName: 'Visible'
});
var _default = Visible;
exports["default"] = _default;
module.exports = exports.default;